import { Injectable } from '@angular/core';
import { ResourcesApiService } from './api/resources-api.service';

@Injectable({
  providedIn: 'root',
})
export class DeliveryOverviewResourcesService {
  constructor(private apiService: ResourcesApiService) {}

  createIfs$(ifs: string) {
    return this.apiService.createResource(ifs);
  }
}
